// Single source for the Maps JS loader options. Every useLoadScript caller
// must pass identical options, or the loader throws when a second page
// mounts with different ones.
//
// The key is a public browser key: it ships in the bundle by design, and the
// real protection is the HTTP-referrer + API restrictions on the key in the
// Google Cloud console. It comes from the deploy workflows' env mapping (repo
// secret REACT_APP_GOOGLE_MAPS_API_KEY); for local dev put it in the
// gitignored frontend/.env. With no key, the map cannot render and the
// address fields degrade to plain typing.
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

export const GOOGLE_MAP_LIBRARIES = ["places"];
